import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import loadable, { LoadableLibrary } from '@loadable/component';

import { Container } from '../../../../../symphony';

import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../../global-interface';
import { ErrorCodes } from '../../../../../api/private/global.interface';
import {
	MaterialType, IMaterialStatus, IMaterialInfo, IMaterialChange,
} from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

const CodeCoach: LoadableLibrary<unknown> = loadable.lib(
	() => import(/* webpackPrefetch: true */ '../../../../../leCodeCoach/public/SlLeCodeCoach/SlLeCodeCoach'),
);

interface ICodeCoachMaterialProps {
	type?: MaterialType;
}

export function CodeCoachMaterial({
	type = MaterialType.CodeCoach,
}: ICodeCoachMaterialProps): JSX.Element {
	const { materialId, courseAlias } = useParams();
	const { actions$ } = Container.take(SlLEContext, SlActions);

	useEffect(() => {
		actions$.next({
			type: ActionType.OnCCMaterialMount,
			requestType: RequestType.Parallel,
			data: {
				alias: courseAlias,
				materialId: +materialId,
			},
		});
	}, []);

	const solveMaterialCallback = (
		statusChanges: IMaterialStatus[],
		materialInfo?: IMaterialInfo,
	): void => {
		actions$.next({
			type: ActionType.SolveMaterialCallback,
			requestType: RequestType.Parallel,
			data: {
				statusChanges,
				solutions: null,
				materialInfo,
			},
		});
	};

	const makeMaterialChanges = (materialChanges: IMaterialChange[]): void => {
		actions$.next({
			type: ActionType.MakeMaterialChanges,
			requestType: RequestType.Parallel,
			data: {
				materialChanges,
			},
		});
	};

	const onSessionError = () => {
		actions$.next({
			type: ActionType.ExpiredSessionIdError,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<CodeCoach>
			{({ SlLeCodeCoach }) => (
				<SlLeCodeCoach
					configs={{
						materialId: Number(materialId),
						type,
						solveMaterialCallback,
						courseAlias,
						makeMaterialChanges,
					}}
					errorHandler={{
						[ErrorCodes.ExpiredSession]: onSessionError,
					}}
				/>
			)}
		</CodeCoach>
	);
}
